// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-container[data-v-0402cbc1]{overflow-x:auto}.editable[data-v-0402cbc1]{margin-left:8px}", ""]);
// Exports
module.exports = exports;
